import { confirmation, notify } from '@/components';
import {useDeleteTemplateTaskMutation } from '@/redux';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useDeleteTemplateTask(goBack: boolean) {
  const [unlist] = useDeleteTemplateTaskMutation();
  const push = useNavigate();

  const performUnlist = useCallback(
    (id: string) =>
      unlist({ id }).then(() =>
        notify.success.t('taskTemplates.task.deleted'),
      ),
    [unlist],
  );

  return useCallback(
    (id: string) =>
      confirmation.delete({ key: 'taskTemplates.task.entityName' }, () => {
        performUnlist(id);
        if (goBack) push(-1);
      }),
    [goBack, performUnlist, push],
  );
}

export function useBoundDeleteTemplateTask(id: string | undefined) {
  const unlist = useDeleteTemplateTask(false);
  return useCallback(() => (id ? unlist(id) : Promise.reject()), [id, unlist]);
}